function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import PropTypes from 'prop-types';
import { component } from '@signal/prop-types';
import isString from 'lodash/isString';
import renderIf from '@signal/utils/renderIf';
import { Wrapper, Title, TitleLine, Subtitle, Description } from './styles';
export var propTypes = {
  /**
   * The title of the content section.
   */
  title: component,
  titleProps: PropTypes.object,

  /**
   * The subtitle of the content section.
   * Either a string to use a DOM element or a component
   */
  subtitle: component,

  /**
   * The description of the content section.
   */
  description: component,

  /**
   * The component used for the right content node.
   * Either a string to use a DOM element or a component.
   */
  rightContent: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object])
};
export var ContentSectionHeading = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ContentSectionHeading, _React$PureComponent);

  var _super = _createSuper(ContentSectionHeading);

  function ContentSectionHeading() {
    _classCallCheck(this, ContentSectionHeading);

    return _super.apply(this, arguments);
  }

  _createClass(ContentSectionHeading, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          titleProps = _this$props.titleProps,
          subtitle = _this$props.subtitle,
          description = _this$props.description,
          RightContent = _this$props.rightContent,
          className = _this$props.className,
          style = _this$props.style;
      var shouldRenderTitleLine = title || RightContent;
      return /*#__PURE__*/React.createElement(Wrapper, {
        className: className,
        style: style
      }, renderIf(isString(subtitle), function () {
        return /*#__PURE__*/React.createElement(Subtitle, null, subtitle);
      }, subtitle), renderIf(shouldRenderTitleLine, function () {
        return /*#__PURE__*/React.createElement(TitleLine, null, renderIf(isString(title), function () {
          return /*#__PURE__*/React.createElement(Title, titleProps, title);
        }, title), renderIf(RightContent, RightContent));
      }), renderIf(isString(description), function () {
        return /*#__PURE__*/React.createElement(Description, null, description);
      }, description));
    }
  }]);

  return ContentSectionHeading;
}(React.PureComponent);

_defineProperty(ContentSectionHeading, "propTypes", propTypes);

export default ContentSectionHeading;